import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  uri: `https://login.${process.env.REACT_APP_BASE_API || "samespace.com"}/api`,
  cache: new InMemoryCache(),
});
